var exports = {
  "Pf": "x2b2fbebb--50c627--label",
  "ff": "x2b2fbebb--50c627--pros",
  "qu": "x2b2fbebb--50c627--cons",
};

module.exports = exports;
